import { Route, Routes, useLocation } from "react-router-dom";
// import { PaymentResult } from "../components/PaymentResult";
import { SuccessModal } from "../components/SuccessPayment";
import { FailModal } from "../components/FailPayment";
import { TransitionWrapper } from "../../../components/Transitions/TransitionWrapper";
import { HomePage } from "../pages/HomePage";
import { PaymentSimulation } from "../components/PaymentSimulation";
export const AppRoute = () => {
  const location = useLocation();
  return (
    <TransitionWrapper>
      <Routes location={location}>
        <Route path="" element={<HomePage />} />
        <Route path=":placa" element={<HomePage />} /> {/* Ruta para path param */}
        <Route path="simulacion-pago" element={<PaymentSimulation />} />
        {/* <Route path="payment-result" element={<PaymentResult />} /> */}
        <Route path="/success-payment" element={<SuccessModal />} />
        <Route path="/fail-payment" element = {<FailModal/>} />
      </Routes>
    </TransitionWrapper>
  );
};
